export default __webpack_public_path__ + "static/ing-1e9f5292e2d07032e76ce47e36cf55d6.svg";